/**
 * Get User's initials by First and Last names
 */
export const getInitials = (name: string) =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .reduce((acc, str) => `${acc}${str.charAt(0)}`, '')
    .toUpperCase();
